import React, { Component } from "react";
import ApiConnect from "../../../../Utils/ApiConnect";
import { Modal } from "react-bootstrap";
import ReactDatatable from "@ashvin27/react-datatable";
import { connect } from "react-redux";
import {
  AccountHeads,
  AccountGroups,
} from "../../../../redux/actions/Modules.Action";
import { NavLink as Links } from "react-router-dom";
import Tables from "../../../Components/Tables";
class AccountHeadDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      myFData: [],
      btnDisable: false,
    };
    this.columns = [
      {
        key: "name",
        text: "Account Head",
        cell: (record) => {
          return (
            <React.Fragment>
              {record.name}
              <small> {record.group}</small>
            </React.Fragment>
          );
        },
      },
      {
        key: "limit",
        text: "Limit",
        sortable: true,
      },
      {
        key: "balance",
        text: "Balance",
        sortable: true,
      },
      {
        key: "vat",
        text: "PAN/VAT",
        sortable: true,
      },
      {
        key: "address",
        text: "Address",
      },
      {
        key: "contact",
        text: "Contact",
        sortable: true,
      },
      {
        key: "mail",
        text: "E-mail",
      },
      {
        key: "action",
        text: "Action",
        className: "table-actions",
        width: 150,

        align: "center",
        cell: (record) => {
          return (
            <React.Fragment>
              <button className="table-action btn btn-square btn-pure hover-warning">
                <span className="material-icons-outlined">edit_note</span>
              </button>
              <button className="table-action btn btn-square btn-pure hover-danger">
                <span className="material-icons-outlined">delete</span>
              </button>
              <Links
                to={`${this.props.location.pathname}/View/${record.id}`}
                className="table-action btn btn-square btn-pure hover-success"
              >
                <span className="material-icons-outlined">visibility</span>
              </Links>
            </React.Fragment>
          );
        },
      },
    ];
    this.cols = [
      {
        accessor: "name",
        Header: "Account Head",
        canSort: true,
      },
      {
        accessor: "limit",
        Header: "Limit",
      },
      {
        accessor: "balance",
        Header: "Balance",
      },
      {
        accessor: "vat",
        Header: "PAN/VAT",
      },
      {
        accessor: "address",
        Header: "Address",
      },
      {
        accessor: "contact",
        Header: "Contact",
      },
      {
        accessor: "mail",
        Header: "E-mail",
      },
      {
        accessor: "action",
        Header: "Action",
        className: "table-actions",
        width: 150,
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 10,
      length_menu: [10, 20, 50],
      show_filter: true,
      show_pagination: true,
      button: {
        excel: true,
        print: true,
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchAccountDetails();
  }
  fetchAccountDetails() {
    ApiConnect.get("/Module/Accounts/AccountHead/Details")
      .then((response) => {
        this.props.AccountHeads(response.data);
      })
      .catch((error) => console.log(error));
  }

  render() {
    return (
      <>
        <div className="dataTables_wrapper">
          {/* <Tables coldata={this.cols} data={this.props.AccountHeadData} /> */}
          <ReactDatatable
            className="table table-separated"
            config={this.config}
            records={this.props.AccountHeadData}
            columns={this.columns}
          />
        </div>
      </>
    );
  }
}
export default connect(
  (state) => ({
    AccountHeadData: state.Accounts.AccountHead,
    AccountGroupData: state.Accounts.AccountGroup,
  }),
  { AccountHeads, AccountGroups }
)(AccountHeadDetails);
